import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer-container" }
const _hoisted_2 = { class: "links-section" }
const _hoisted_3 = { class: "links-container" }

import { ref, onMounted } from 'vue';
import MenuBox from '@/components/boxChange/boxTop.vue';
import { friendlyLink, brotherLink } from '@/pubilc/data';


export default /*@__PURE__*/_defineComponent({
  __name: 'footer',
  setup(__props) {

const menulist = ref([
  {
    value: 1,
    label: '政府网站',
    children: [ ...friendlyLink ]
  },
  {
    value: 2,
    label: '兄弟学（协）会',
    children: [ ...brotherLink ]
  },
])


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(MenuBox, {
          "is-type": 'top',
          list: menulist.value
        }, null, 8, ["list"])
      ])
    ]),
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"contact-section\" data-v-65983a4c><div class=\"contact-info\" data-v-65983a4c><div class=\"info-item\" data-v-65983a4c><span data-v-65983a4c>技术支持：(0531) 61303517</span></div><div class=\"info-item\" data-v-65983a4c><span data-v-65983a4c>邮箱：smscbgs@163.com</span></div><div class=\"info-item\" data-v-65983a4c><span data-v-65983a4c>地址：济南市历城区华悦路汉峪金谷A6-2栋</span></div><div class=\"info-item\" data-v-65983a4c><span data-v-65983a4c>工信部链接：<a href=\"https://beian.miit.gov.cn/\" target=\"_blank\" data-v-65983a4c>https://beian.miit.gov.cn/</a></span></div></div></div><div class=\"copyright-section\" data-v-65983a4c><p data-v-65983a4c>山东省神经科学学会、山东省阿尔茨海默病防治协会版权所有 © 2024 sdssjkxxh.com All Rights Reserved</p><p data-v-65983a4c>备案证号：鲁ICP备2024114083号</p></div>", 2))
  ]))
}
}

})